<template>
<el-dialog :title="title" :visible.sync="syncDialog" :close-on-click-modal="false" size="small" class="text-left item-integration-dialog is-restore" :close-on-press-escape="(enableCloseOnPressEscape && !isAnyRowLoading)" :show-close="(showClose && !isAnyRowLoading)" @close="fnClose" @opened="initSpreadsheet" ref="dialog">
    <div class="integration-dialog-body" v-loading="getFetchLoading">
        <div class="dialog-body-header p-1">
            <el-radio  v-model="databaseCheckedOptions" border style="border-color: #409EFF;" class="mr-1" v-for="item in getDb" :key="item.value" :label="item.value">{{ item.name }}</el-radio>
        </div>
        <div ref="spreadsheet"></div>
    </div>
    <div slot="footer" class="dialog-footer">
            <mdb-btn @click="fnRun" color="elegant" size="sm" :disabled="(isAnyRowLoading || getFetchLoading)">Run</mdb-btn>
            <mdb-btn @click="fnClose" color="elegant" size="sm" :disabled="(isAnyRowLoading)">Close</mdb-btn>
        </div>
</el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import jspreadsheet from '../../jsexcel/jexcel'
import {mdbBtn} from 'mdbvue'
import {MessageBox} from 'element-ui'
export default {
    components : {
        mdbBtn
    },
    inject : ['brandProvider','categoryProvider','areaProvider','collectionProvider'],
    data() {
        return {
            syncDialog: false,
            showClose: true,
            processing : false,
            selected : null,
            rowLoading: {},
            spreadsheet: null,
            databaseCheckedOptions : '',
            enableCloseOnPressEscape : true,
            filteredBrands : [],
            spreadsheetOptions : {
                download : false,
                allowDeleteColumn : false,
                allowRenameColumn : false,
                defaultColAlign : 'left',
                allowInsertColumn : false,
                csvHeader:true,
                tableWidth : '100%',
                tableHeight : 'calc(100vh - 335px)',
                tableOverflow : true,
                data:[[]],
                minDimensions:[3,50],
                onCopy : null,
                selectionCopy : false,
                allowCopy : true,
                columns: [
                    {
                        type: 'text',
                        width: '250px',
                        title: 'Series',
                        name: 'series',
                        readOnly: false,
                        primaryKey: false
                    },
                    {
                        type: 'text',
                        width: '200px',
                        title: 'Status',
                        name: 'status',
                        readOnly: true,
                    },
                    {
                        type: 'text',
                        width: '340px',
                        title: 'Response',
                        name: 'message',
                        readOnly: true,
                    }
                ],
                contextMenu: function() {
                    return false;
                }
            }
        }
    },

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        endpoint : {
            type : String,
            default : 'item-master-integration'
        },
        group : {
            type : Number,
            default : 2
        },
        defaultDatabase : {
            type : String,
            default : 'THATSLIVING_DEV'
        },
        title : {
            type : String,
            default : 'DATA INTEGRATION'
        }
    },
    
    methods: {
        ...mapActions('DataIntegrationModule', ['fetchDb','integrate']),
        fnClose(){
            this.syncDialog = false;
            this.$emit('close');
        },

        fnRun(){
            // this.$emit('run');

            MessageBox.confirm(
                `Are you sure you want to run this integration? This will be push to ${this.databaseCheckedOptions}.`,
                'Confirmation',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning'
                }
            ).then(() => {
                this.fnPostData();
            })
        },

        fnPostData(){
            const self = this;
            const tableData = this.spreadsheet.getJson();
            if(tableData.length > 0 && this.processing == false){
                console.log(tableData)
                
                const filterData = tableData.filter(function(rowElement){
                    return (rowElement.series != "");
                },[])

                if(filterData.length == 0){
                    this.$ThatsNotify.error({message : 'Please select at least one item', type : 'error'})
                    return false;
                }

                if(filterData.length > 0){      

                    this.processing = true;
                    tableData.forEach((element, forIndex) => {
                      const row = 1 + forIndex

                      if(element.series !== ''){
                        self.processing = true;
                        self.spreadsheet.setValue(`B${row}`,'Please wait...',true);
                        self.$set(self.rowLoading, row, true);
                        self.integrate({endpoint : self.endpoint,series : element.series, index : row, connection : self.databaseCheckedOptions}).then((response) => {
                                  const i = parseInt(response.index);
  
                                  self.spreadsheet.setStyle(`A${i}`,'background-color','#00c851',true);
                                  self.spreadsheet.setStyle(`B${i}`,'background-color','#00c851',true);
                                  self.spreadsheet.setStyle(`C${i}`,'background-color','#00c851',true);
                                  self.spreadsheet.setValue(`B${i}`,'Success...',true);
                                  self.spreadsheet.setValue(`C${i}`,response.message,true);
                                  self.processing = false
                                  self.postCounter++
                                  self.$set(self.rowLoading, i, false);
                                }).catch((error) => {
  
                                    const i = parseInt(error.response.data.index)
                                    self.spreadsheet.setValue(`B${i}`,'Failed...',true);
                                    if(error.response.data?.hasOwnProperty('message')){
                                      self.spreadsheet.setValue(`C${i}`,error.response.data.message,true);
                                    }else{

                                      if(error.response.data?.errors?.hasOwnProperty('value')){
                                        self.spreadsheet.setValue(`C${i}`,error.response.data.errors.value,true);
                                      }
                                    }

                                    self.spreadsheet.setStyle(`A${i}`,'background-color','#fb3',true);
                                    self.spreadsheet.setStyle(`B${i}`,'background-color','#fb3',true);
                                    self.spreadsheet.setStyle(`C${i}`,'background-color','#fb3',true);
                                    self.processing = false
                                    self.postCounter++
                                    self.$set(self.rowLoading, i, false);
                                });
                              }
                            
                    });

                }
            }  
        },
        openDialog(){
            this.syncDialog = true;
            this.fetchDb();
            this.databaseCheckedOptions = this.defaultDatabase;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.initSpreadsheet();
                });
            });
        },
        createPopupTable(jspreadsheetOptions){
            const el = this.$refs.dialog.$el;
            const firstChild = el?.firstElementChild;
            const width = firstChild?.offsetWidth;
            const widthForTable = width - 70;
            const sections = [
                widthForTable * 0.2,  
                widthForTable * 0.3, 
                widthForTable * 0.5  
            ];

            const existingColumns = jspreadsheetOptions.columns;

            jspreadsheetOptions.tableWidth = `${width}px`;
            jspreadsheetOptions.columns = existingColumns.map((column, index) => {
                return {
                    ...column,
                    width: `${sections[index]}px`
                };
            });

            console.log("jspreadsheetOptions",jspreadsheetOptions)

            this.spreadsheet = jspreadsheet(this.$refs.spreadsheet, jspreadsheetOptions);
            Object.assign(this, this.spreadsheet);
            this.spreadsheet.setData([])
        },

        async recreateSpreadsheet(){
            if(this.spreadsheet){
                await this.spreadsheet.destroy();
            }
        },

        initSpreadsheet() {
            this.recreateSpreadsheet();   
            this.createPopupTable(this.spreadsheetOptions);
        },

        clearForm(){
            this.recreateSpreadsheet();
            this.createPopupTable(this.spreadsheetOptions);
        }
    },

    watch: {
        visible: function (val) {
            this.syncDialog = val;
            
            if(val){
                this.fetchDb();
            }
        },
        brandComputed : function(v){
            this.filteredBrands = v
        },
    },

    computed: {
        ...mapGetters('DataIntegrationModule', ['getDb','getFetchLoading']),
        isAnyRowLoading() {
            return Object.values(this.rowLoading).some((v) => v);
        },

        brandComputed : function(){
            const brandProvider =  this.brandProvider();

            return brandProvider.map((item) => {
                const name = `${item.code} - ${item.brand}`
                return {...item,name : name.toUpperCase(),id : item.code}
            },[])
        },
        groupComputed : function(){
            const brandProviderData = this.brandProvider();
            return brandProviderData.filter((item) => item.parent == 0,[]).map((item) => {
                const name = `${item.code} - ${item.brand}`
                return {...item,name : name.toUpperCase(),id : item.code}
            },[])
        },

        categoryComputed : function(){
            return this.categoryProvider().map((item) => {
                const name = `${item.code} - ${item.category}`
                return {...item,name : name.toUpperCase(),id : item.code}
            },[])
        },
        areaComputed : function(){
            return this.areaProvider().map((item) => {
                const name = `${item.code} - ${item.area}`
                return {...item,name : name.toUpperCase(),id : item.code}
            },[])
        },

        collectionComputed : function(){
            return this.collectionProvider();
        },
    }
}
</script>
<style scoped>
.select-location-item{
    text-transform : uppercase;
    font-size : 12px;
}
</style>